import { handleAction, handleActions } from 'redux-actions';
import { setRefundInfo } from './actions';
const initialState = {};
const handleSetRefundInfo = handleAction(setRefundInfo, (state, { payload }) => (Object.assign({}, payload)), initialState);
export default handleActions({
    [setRefundInfo.toString()]: handleSetRefundInfo
}, initialState);
